<template>
	<nav v-if="notEmptyCategories.length > 0" class="nav-menu">
		<span
			v-for="(category, index) in notEmptyCategories"
			class="nav-menu__item"
			:key="`sidebarNav_${category.name}_${index}`"
		>
			<span
				class="nav-menu__item__link"
				:class="{
					'nav-menu__item__link--active':
						$route.params.category === category.name
				}"
				@click="$emit('nav-item-click', { category, index })"
			>
				<span class="nav-menu__title">
					{{ category.name || '' }}
					<span class="nav-menu__title__quantity">
						<span>(</span>{{ category.numProducts }}<span>)</span>
					</span>
				</span>
			</span>
		</span>
	</nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'SideNav',
	computed: {
		...mapGetters('productCatalog', ['notEmptyCategories'])
	}
}
</script>

<style lang="scss" scoped>
@import './src/assets/styles/variables';

.nav-menu {
	flex-grow: 1;
	margin: 0 -16px;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;

	@media (min-width: 1025px) {
		padding: 12px 0;
		margin: 0;
	}

	&__item {
		display: block;
		text-decoration: none;
		border-radius: 8px;

		&__link {
			position: relative;
			padding: 13px 12px;
			display: block;
			font-size: 16px;
			line-height: 21px;
			margin-bottom: 16px;
			text-decoration: none;
			box-shadow: 0 0 8px 0 rgba($black, 0);
			cursor: pointer;
			border: 1px solid transparent;
			transition: font-size 0.5s, box-shadow 0.7s, border-color 0.3s;

			&--active {
				border-color: $plasma-pink;

				@media (max-width: 1024px) {
					border-color: transparent;

					&::after {
						content: '';
						position: absolute;
						top: calc(50% - 8px);
						left: 0;
						width: 2px;
						height: 16px;
						background-color: $white;
						border-radius: 2px;
					}
				}
			}

			@media (max-width: 1024px) {
				margin-bottom: 0;
				font-size: 14px;
				padding: 10px 16px;
				box-shadow: none;
			}

			&:hover {
				@media (min-width: 1025px) {
					font-size: 18px;
					box-shadow: 0 0 8px 0 rgba($black, 0.8);
					background-color: rgba($violet-grey, 0.8);
				}
			}
		}
	}

	&__title {
		display: block;
		color: $white;
		text-transform: capitalize;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;

		@media (max-width: 1024px) {
			letter-spacing: -0.6px;
			display: flex;
			justify-content: space-between;
		}
		&__quantity {
			letter-spacing: normal;

			span {
				@media (max-width: 1024px) {
					display: none;
				}
			}
		}
		&__bottom-row {
			display: none;
			text-transform: none;
			padding-top: 4px;
			@media (max-width: 1024px) {
				display: block;
				letter-spacing: -0.5px;
			}
		}
	}
}
</style>
